import React, {
  useState,
  useEffect,
  createContext,
  PropsWithChildren,
} from "react";

import { UserResponse } from "../types/hooks/user";
import { Drive } from "../hooks/drive";
import { Employee } from "../hooks/employee";

type UserContextProps = {
  isLoggedIn: boolean;
  setIsLoggedIn: React.Dispatch<React.SetStateAction<boolean>>;

  accessToken: string;
  setAccessToken: React.Dispatch<React.SetStateAction<string>>;

  user: UserResponse;
  setUser: React.Dispatch<React.SetStateAction<UserResponse>>;

  drives: Drive[];
  setDrives: React.Dispatch<React.SetStateAction<Drive[]>>;

  driveData: Drive[];
  setDriveData: React.Dispatch<React.SetStateAction<Drive[]>>;

  emp: Employee;
  setEmp: React.Dispatch<React.SetStateAction<Employee>>;
};

const UserContext = createContext<UserContextProps>({} as UserContextProps);

type ProviderProps = PropsWithChildren<{}>;

export const UserProvider = ({ children }: ProviderProps): JSX.Element => {
  const isLoggedInKey = "isLoggedIn";
  const accessTokenKey = "accessToken";
  const userKey = "user";
  const empKey = "emp";

  const isLoggedInLocal = localStorage.getItem(isLoggedInKey);
  const accessTokenKeyInLocal = localStorage.getItem(accessTokenKey);
  const userKeyInLocal = localStorage.getItem(userKey);
  const empKeyInLocal = localStorage.getItem(empKey);

  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(
    isLoggedInLocal ? JSON.parse(isLoggedInLocal) : false
  );

  const [accessToken, setAccessToken] = useState<string>(
    accessTokenKeyInLocal ? JSON.parse(accessTokenKeyInLocal) : ""
  );

  const [user, setUser] = useState<UserResponse>(
    userKeyInLocal ? JSON.parse(userKeyInLocal) : ({} as UserResponse)
  );

  const [emp, setEmp] = useState<Employee>(
    empKeyInLocal ? JSON.parse(empKeyInLocal) : ({} as Employee)
  );

  const [drives, setDrives] = useState<Drive[]>([]);
  const [driveData, setDriveData] = useState<Drive[]>([]);

  useEffect(() => {
    localStorage.setItem(isLoggedInKey, JSON.stringify(isLoggedIn));
  }, [isLoggedIn]);

  useEffect(() => {
    localStorage.setItem(accessTokenKey, JSON.stringify(accessToken));
  }, [accessToken]);

  useEffect(() => {
    localStorage.setItem(userKey, JSON.stringify(user));
  }, [user]);

  useEffect(() => {
    localStorage.setItem(empKey, JSON.stringify(emp));
  }, [emp]);

  return (
    <UserContext.Provider
      value={{
        isLoggedIn,
        setIsLoggedIn,
        accessToken,
        setAccessToken,
        user,
        setUser,
        drives,
        setDrives,
        emp,
        setEmp,
        driveData,
        setDriveData,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserContext;

// import React,{useState,useEffect,createContext} from 'react'
// import { UserResponse } from '../types/hooks/user'
// import { useCookies } from 'react-cookie';
// import { Drive } from '../hooks/drive';
// import { Employee } from '../hooks/employee';

// type UserContextProps = {
//     isLoggedIn: boolean
//     setIsLoggedIn: React.Dispatch<React.SetStateAction<boolean>>
//     accessToken: string
//     setAccessToken: React.Dispatch<React.SetStateAction<string>>
//     user: UserResponse
//     setUser: React.Dispatch<React.SetStateAction<UserResponse>>

//     drives: Drive[]
//     setDrives: React.Dispatch<React.SetStateAction<Drive[]>>

//     driveData: Drive[]
//     setDriveData: React.Dispatch<React.SetStateAction<Drive[]>>
  

//     emp: Employee
//     setEmp: React.Dispatch<React.SetStateAction<Employee>>
// }

// const UserContext = createContext({} as UserContextProps)

// export const UserProvider: React.FC = (props) => {
//     const isLoggedInKey = 'isLoggedIn'
//     const accessTokenKey = 'accessToken'
//     const userKey = 'user'
//     const empKey = 'emp'

//     const isLoggedInLocal = localStorage.getItem(isLoggedInKey)
//     const accessTokenKeyInLocal = localStorage.getItem(accessTokenKey)
//     const userKeyInlocal = localStorage.getItem(userKey)

//     const empKeyInlocal = localStorage.getItem(empKey)

//     const [isLoggedIn,setIsLoggedIn] = useState<boolean>(isLoggedInLocal ? JSON.parse(isLoggedInLocal) : false)
//     const [accessToken,setAccessToken] = useState<string>(accessTokenKeyInLocal ? JSON.parse(accessTokenKeyInLocal) : '')
//     const [user,setUser] = useState<UserResponse>(userKeyInlocal ? JSON.parse(userKeyInlocal) : {})
//     const [emp,setEmp] = useState<Employee>(empKeyInlocal ? JSON.parse(empKeyInlocal) : {})
//     const [drives,setDrives] = useState<Drive[]>([])
//     const [driveData,setDriveData] = useState<Drive[]>([])
//     //const [cookies, setCookie, removeCookie] = useCookies(['sso']);

//     useEffect(() => {
//         localStorage.setItem(isLoggedInKey,JSON.stringify(isLoggedIn))

//     },[isLoggedIn])

//     useEffect(() => {
//         localStorage.setItem(accessTokenKey,JSON.stringify(accessToken))

//     },[accessToken])

//     useEffect(() => {
//         localStorage.setItem(userKey,JSON.stringify(user))

//     },[user])

//     useEffect(() => {
//         localStorage.setItem(empKey,JSON.stringify(emp))

//     },[emp])

   

//     return (
//         <UserContext.Provider
//             value={
//                 {
//                     isLoggedIn,
//                     accessToken,
//                     user,
//                     setIsLoggedIn,
//                     setAccessToken,
//                     setUser,
//                     drives,
//                     setDrives,
//                     emp,
//                     setEmp,
//                     driveData,
//                     setDriveData,
//                 }
//             }
//         >
//             {props.children}
//         </UserContext.Provider>
//     )
// }

// export default UserContext